

export function keyGenerator(url: string, selector: string): string {
  return `${url} || ${selector}`;
}


export async function createVDOMHash(vdom: any): Promise<string> {
  const vdomString = JSON.stringify(vdom);
  const encoded = new TextEncoder().encode(vdomString); // possibly SharedArrayBuffer
  const safeEncoded = new Uint8Array([...encoded]); // guaranteed plain ArrayBuffer backing
  const hashBuffer = await crypto.subtle.digest('SHA-256', safeEncoded); // ✅ No error
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}



